import {
  Center,
  Flex,
  Heading,
  IconButton,
  Td,
  Tooltip,
  useDisclosure,
  VStack,
} from "@chakra-ui/react";
import React, { useContext, useEffect, useState } from "react";
import { fetchController } from "../../../utils/FetchController/fetchController";
import Loader from "../../../utils/Loader/Loader";
import { getHostDomain } from "../../../utils/utils";
import AddAgent from "../../Modals/AddAgent";
import Table from "../../Tables/Table";
import { AgencyContext } from "../AgencyProvider/AgencyProvider";
import { SettingContext } from "../Reducer/SettingProvider";
import ConfirmationModal from "../../Modals/Confirmation";
import { toast } from "react-toastify";
import { MdDatasetLinked, MdDelete } from "react-icons/md";
import AgentLinkModal from "./AgentLinkModal";
import Paginator from "../../../utils/Loader/Paginator";
import PaginationSizeSelect from "../../../utils/Loader/PaginationSizeSelect";
import { AddIcon } from "@chakra-ui/icons";

const Agent = () => {
  const baseUrl = getHostDomain();
  const { isOpen, onOpen, onClose } = useDisclosure();
  const {
    isOpen: isConfirmationModalOpen,
    onOpen: onOpenConfirmationModal,
    onClose: onCloseConfirmationModal,
  } = useDisclosure();
  const {
    isOpen: isOpenLinkAgentModal,
    onOpen: onOpenLinkAgentModal,
    onClose: closeLinkAgentModal,
  } = useDisclosure();
  const [agentTobeOperate, setAgentTobeOperate] = useState(null);
  const [isInitialLoad, setIsInitialLoad] = useState(true);
  const [status, setStatus] = useState("idle");
  const [tableData, setTableData] = useState([]);
  const [heads, setHeads] = useState([]);
  const loading = status === "loading" && isInitialLoad;
  const { state: user } = useContext(SettingContext);
  const [page, setPage] = useState(1);
  const [pages, setPages] = useState(0);
  const [paginationSize, setPaginationSize] = useState(10);

  const loadAgent = async () => {
    try {
      setStatus("loading");
      const url =
        baseUrl +
        `/api/v1/user/get_agent_list/?page=${page}&size=${paginationSize}`;
      const response = await fetchController(url, "GET");
      setPages(response?.data?.pages);
      const tableData = response.data.items.map((item, index) => {
        return {
          SNo: index + 1,
          id: item.id,
          name: item.first_name + " " + item.last_name,
          email: item.email,
          operation: (
            <Td cursor="pointer" p={2}>
              <Flex gap="2" marginLeft="20px">
                <Tooltip label="Delete agent" aria-label="Delete agent">
                  <Center>
                    <MdDelete
                      onClick={() => {
                        setAgentTobeOperate(item);
                        onOpenConfirmationModal();
                      }}
                      color="red"
                    />
                  </Center>
                </Tooltip>
                <Tooltip label="Link Assistant" aria-label="Link Assistant">
                  <Center>
                    <MdDatasetLinked
                      onClick={() => {
                        setAgentTobeOperate(item);
                        onOpenLinkAgentModal();
                      }}
                    />
                  </Center>
                </Tooltip>
              </Flex>
            </Td>
          ),
        };
      });

      const heads = ["SNo", "name", "email", "operation"];
      const columns = heads.map((key) => ({
        Header: key,
        accessor: key,
        Filter: ({ column }) => <input {...column.filterProps} />,
      }));
      setTableData(tableData);
      setHeads(columns);
      setStatus("success");
    } catch (error) {
      setStatus("failure");
      console.log({ error });
    } finally {
      setIsInitialLoad(false);
    }
  };
  useEffect(() => {
    loadAgent();
  }, [page, paginationSize]);
  const agency = useContext(AgencyContext);
  const { textColor, buttonColorScheme } = agency;
  const onConfirmDelete = async () => {
    if (!agentTobeOperate) return;
    handleDeleteAgent(agentTobeOperate);
    onCloseConfirmationModal();
  };
  const handleDeleteAgent = async (item) => {
    try {
      const endpoint = `/api/v1/user/remove_agent/${item.id}`;
      const url = baseUrl + endpoint;
      await fetchController(url, "DELETE");
      toast.success("Agent deleted successfully.");
      await loadAgent();
    } catch (error) {
      toast.error(error);
    }
  };
  return (
    <>
      <Flex direction={"column"} gap={3} h={"95%"} w={"100%"}>
        <Flex gap={2} w={"100%"} alignItems="center" p={2}>
          <Heading color={textColor} fontSize="xl">
            Manage Human Agent
          </Heading>
          <Tooltip label="Add">
            <IconButton
              colorScheme={buttonColorScheme}
              onClick={() => onOpen()}
              icon={<AddIcon />}
              size={"xs"}
              isDisabled={
                user?.credits?.human_agents
                  ? user?.credits?.human_agents <= tableData.length
                  : true
              }
            />
          </Tooltip>
        </Flex>

        {loading ? (
          <Loader />
        ) : (
          <Table
            fetch={loadAgent}
            columns={heads}
            data={tableData}
            table="agents"
          />
        )}
      </Flex>

      <Flex
        justifyContent={"flex-end"}
        alignItems={"center"}
        w={"100%"}
        gap={2}
        mr={36}
      >
        <PaginationSizeSelect
          paginationSize={paginationSize}
          setPaginationSize={setPaginationSize}
          tableLength={tableData.length}
        />
        <Paginator
          colorScheme={buttonColorScheme}
          onChangePage={setPage}
          page={page}
          pages={pages}
        />
      </Flex>

      <AddAgent
        isOpen={isOpen}
        onOpen={onOpen}
        onClose={onClose}
        loadAgent={loadAgent}
        buttonColorScheme={buttonColorScheme}
        textColor={textColor}
      />
      <ConfirmationModal
        table={"agents"}
        isOpen={isConfirmationModalOpen}
        onConfirm={onConfirmDelete}
        onClose={onCloseConfirmationModal}
      />
      {isOpenLinkAgentModal ? (
        <AgentLinkModal
          agentTobeOperate={agentTobeOperate}
          setAgentTobeOperate={setAgentTobeOperate}
          isOpen={isOpenLinkAgentModal}
          onClose={closeLinkAgentModal}
        />
      ) : null}
    </>
  );
};

export default Agent;
